import React from "react";
import { Tooltip } from "antd";
import "./TierBadge.less";

const TierBadge = ({ label, tooltip }) => {
  if (!label) return null;

  return (
    <Tooltip title={tooltip}>
      <span className="ecp-tier-badge">
        <span aria-hidden>⚠</span> {label}
      </span>
    </Tooltip>
  );
};

export default TierBadge;
